import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { AppContext } from "../../../context";
import { PillButton, TextButton } from "../../../components/Button";
import styles from "./ListView.scss";

const ListView = ({ data, selectedItem, onSelectItem }) => {
	const [useAppState] = AppContext.useAppContext();
	const itemToString = gateway => ({
		label: gateway.Name,
		value: gateway.Code,
	});

	const handleOnSelect = gateway => {
		onSelectItem(itemToString(gateway));
	};

	return (
		<>
			<p className={styles.heading}>{useAppState.getDictionary("where-are-you-departing-from")}</p>
			<div className={styles.scroll} body-scroll-lock-ignore="true">
				{data?.popularGateways && (
					<ul
						className={styles.popularAirports}
						aria-label={useAppState.getDictionary("most-popular-airports")}>
						{data?.popularGateways?.map(gateway => (
							<li key={gateway.Code}>
								<PillButton
									brand={useAppState.brand}
									onClick={() => handleOnSelect(gateway)}
									label={gateway.Name}
								/>
							</li>
						))}
					</ul>
				)}
				<ul
					className={styles.gatewayGroups}
					aria-label={useAppState.getDictionary("select-from-all-departure-airports")}>
					{data?.gatewayGroups?.map(group => (
						<li key={group.Code}>
							{group.Code}
							<ul className={styles.group}>
								{group.Gateways.map(gateway => (
									<li key={gateway.Code}>
										<TextButton
											type="button"
											className={cx(
												styles.gateway,
												JSON.stringify(selectedItem) === JSON.stringify(itemToString(gateway)) &&
													styles.selected
											)}
											onClick={() => handleOnSelect(gateway)}
											label={gateway.Name}
										/>
									</li>
								))}
							</ul>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

ListView.propTypes = {
	data: PropTypes.shape({
		popularGateways: PropTypes.arrayOf(
			PropTypes.shape({
				Name: PropTypes.string,
				Code: PropTypes.string,
			})
		),
		gatewayGroups: PropTypes.arrayOf(
			PropTypes.shape({
				Name: PropTypes.string,
				Code: PropTypes.string,
				Gateways: PropTypes.arrayOf(
					PropTypes.shape({
						Name: PropTypes.string,
						Code: PropTypes.string,
					})
				),
			})
		),
	}).isRequired,
	selectedItem: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string,
	}),
	onSelectItem: PropTypes.func,
};

ListView.defaultProps = {
	selectedItem: null,
	onSelectItem: () => {},
};

export default ListView;
export { ListView };
